import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';

import { Title } from '@restworld/ui-ds';
import { getAssetSrc, customImageLoader } from '@restworld/utils-common';

function SubscriptionCancellationSuccessScreen() {
  const { t } = useTranslation('payment-and-invoices');

  return (
    <div>
      <Title textColor="neutral-700" fontSize="base" twStyle={tw`text-center`}>
        {t('you_have_successfully_canceled_the_slot_key')}
      </Title>
      <div tw="grid place-items-center mt-6">
        <Image
          src={getAssetSrc('/utils-assets/lead-user.svg')}
          alt=""
          width={340}
          height={340}
          loader={customImageLoader}
        />
      </div>
    </div>
  );
}

export default SubscriptionCancellationSuccessScreen;
